// The six highest-value Palworld TCG chase printings that own a dedicated
// valuation page at /palworld-card-value/<code>. Kept in its own module so the
// sitemap, header and search index can read the list without importing a route.
export interface ChaseValueCard {
  code: string;
  /** Why this printing carries its price — shown on the valuation page. */
  angle: string;
}

export const CHASE_VALUE_CARDS: ChaseValueCard[] = [
  {
    code: "ETD01-001TSP",
    angle:
      "Grizzbolt's Trial Deck secret parallel is the hardest Trial Deck pull in English, and Grizzbolt's popularity from the game keeps demand well above its print run.",
  },
  {
    code: "EBP01-025SSP",
    angle:
      "Chillet's SSP is the poster chase of Dawn of Palpagos, so it sets the ceiling most collectors price the rest of the BP01 parallels against.",
  },
  {
    code: "EBP01-001SSP",
    angle:
      "Jormuntide Ignis is card 001 of the first English booster set, and the SSP finish of a set's opening card carries collector weight beyond its playability.",
  },
  {
    code: "ETD02-012TSP",
    angle:
      "Astegon's TD02 secret parallel entered a much smaller print window than the BP01 chases, so thin listing depth swings the price quickly.",
  },
  {
    code: "ESOUL-002",
    angle:
      "The gold Cattiva Soul is the SSS Ultra Secret Gold Card, the scarcest Soul printing in English, and the only Soul card collectors chase at booster-hit prices.",
  },
  {
    code: "EBP01-049SSP",
    angle:
      "Lyleen's SSP has the strongest crossover pull between deck players and art collectors in BP01, which keeps both raw and graded asks firm.",
  },
];

export const CHASE_VALUE_BY_CODE = new Map(CHASE_VALUE_CARDS.map((c) => [c.code.toUpperCase(), c]));

export const chaseValuePath = (code: string): string => `/palworld-card-value/${code.toUpperCase()}`;
